import React, {FC} from 'react';
import styled from 'styled-components';

import {inboxHasColor} from '../../../../libs/shared/core/src/models/helpers/inboxHelpers';
import {ColorDot} from '../../../../libs/shared/ui/src/components/utility/colorDot';
import {useUserTheme} from '../../../../libs/shared/ui/src/theme/userThemeProvider';
import {useAppSelector} from '../../../helpers/appReduxHelpers';
import {getInboxes} from '../../../store/data/inboxes/inboxesSelectors';
import {MetricResourceRenderer} from '../analyticsFormatHelpers';

/*
 * Styles.
 */

const StyledColorDot = styled(ColorDot)`
  margin: 0 7px 0 0;
  display: inline-block;
`;

/*
 * Formatter.
 */

const InboxValue: FC<{inboxId: number; fallback: string}> = ({inboxId, fallback}) => {
  const theme = useUserTheme();
  const allInboxesById = useAppSelector(getInboxes);
  const inbox = allInboxesById[inboxId];

  if (!inbox) {
    return <>{fallback}</>;
  }

  return (
    <>
      <StyledColorDot color={inboxHasColor(inbox) ? inbox.color : theme.greys.shade30} size={8} />
      {inbox.name}
    </>
  );
};

export const renderInboxValue: MetricResourceRenderer = ({id, value}) => (
  <InboxValue inboxId={id} fallback={value} />
);
